import { render, staticRenderFns } from "./DesignStatus.vue?vue&type=template&id=13660930&"
import script from "./DesignStatus.vue?vue&type=script&lang=js&"
export * from "./DesignStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports